import React, { useEffect, useState } from 'react';
import { getNotice } from '../../api/twoDays/board.api';
import { Modal, ModalButton } from './Modal';
import { KST, formatDue } from './model/time';
import Linkify from './Linkify';

/**
 * 운영진 공지 전문 — Inbox 의 공지 알림을 누르면 지금 화면 위에 작은 모달로.
 * 알림 글은 300자까지만 담기므로 서버에서 전문을 읽는다 (목 보드는 알림 글 그대로).
 */
const NoticeModal = ({ notice, slug, live, onClose }) => {
  const [full, setFull] = useState(null);
  const [error, setError] = useState('');
  useEffect(() => {
    setFull(null);
    setError('');
    if (!notice?.id || !live || !slug) return;
    getNotice(slug, notice.id)
      .then(setFull)
      .catch(() => setError('Couldn’t load the announcement.'));
  }, [notice, live, slug]);
  if (!notice) return null;
  const m = /^(?:Announcement|Change event) · (.*?): ([\s\S]*)$/.exec(notice.text ?? '');
  const title = full?.title ?? m?.[1] ?? 'Announcement';
  const body = full?.body ?? m?.[2] ?? notice.text ?? '';
  return (
    <Modal
      open
      title={title}
      subtitle={`Announcement from ops${full?.createdAt ? ` · ${formatDue(full.createdAt, KST)} KST` : ''}`}
      onClose={onClose}
      width='max-w-[480px]'
      sheetOnMobile
      footer={<ModalButton primary onClick={onClose}>Got it</ModalButton>}
    >
      {error && <p className='text-[13px] text-functional-failed04'>{error}</p>}
      <p className='min-w-0 whitespace-pre-line break-words text-[14px] leading-[160%] text-text-primary [overflow-wrap:anywhere] [text-wrap:pretty]'>
        <Linkify text={body} />
      </p>
    </Modal>
  );
};

export default NoticeModal;
